import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form';


const Teaser = ({
  status,
  title,
  view_taxonomy_term,
  offset_path,
  start,
  end,
  paths,
  tide_offset_file,
  tide_prediction_file,
  tide_type,
  daily_prediction_paths,
  years,
  i: id,
  ...props
 }) => {

  const { watch, register } = useForm();

  const [ download, setDownload] = useState([])

  const year = watch('year')
  const format = watch('format')

  useEffect(() => {
    let clone = [];
    if(status === 'prediction' && year && format) {
      clone = [paths[format], `${tide_prediction_file} ${year}.${format}`]
    }
    setDownload(clone)
  }, [year, format])

  return (
    <article className={status === 'offset' ? 'has-gray-icon' : 'has-teal-icon'}>
      <h4>{title}</h4>
      <form>
        {status !== 'offset' && (
          <fieldset>
            <legend>Choose a year and file format</legend>
            <select {...register('year')} id={`year-${id}`}>
              <option value="">- Year -</option>
              {years.map(year => <option key={year} value={year}>{year}</option>)}
            </select>
            <label htmlFor={`year-${id}`} className="sr-only">Year</label>
            <select {...register('format')} id={`format-${id}`}>
              <option value="">- Format -</option>
              <option value="csv">CSV</option>
              <option value="pdf">PDF</option>
            </select>
            <label htmlFor={`format-${id}`} className="sr-only">Format</label>
          </fieldset>
        )}
        {download.length === 0 && status === 'prediction' && <span className="placeholder">Download</span>}
        {download.length > 0 && status === 'prediction' && <a aria-label={`Download for ${title}`} download href={encodeURI(download.join('/'))}>Download</a>}

        {status === 'offset' && <a aria-label={`Download for ${title}`} download href={encodeURI([offset_path, tide_offset_file].join('/'))}>Download</a>}
      </form>
    </article>
  )
}

export default Teaser;
